$(function() {
  $(document).on('click touchend','.js-prodSearchLoading',  function() {
    $('.js-searchLoadingBox').addClass('isActive');
    var hrefURL = $(this).attr('href');
    window.location.href = hrefURL;
  });
  
  // ブラウザバック用対応
  if($('.js-searchLoadingBox').length) {
    // ie
    window.onbeforeunload = function() {};
    // other
    window.onunload = function() {};
    // ios
    window.addEventListener("pageshow", function(event){
      if (event.persisted) {
        window.location.reload();
      }
    });
  }
});
